import React from "react";
import { Badge } from "@/components/ui/badge";

const statusConfig = {
  incomplete: {
    label: "Incomplete",
    class: "bg-blue-600",
  },
  started: {
    label: "Application Started",
    class: "bg-blue-600",
  },
  submitted_for_provisional_sanction: {
    label: "Submitted for Provisional Sanction",
    class: "bg-purple-600",
  },
  field_visit_completed: {
    label: "Field Visit Completed",
    class: "bg-indigo-600",
  },
  provisional_sanction_recommended: {
    label: "Provisional Sanction Recommended",
    class: "bg-green-600",
  },
  provisional_sanction_not_recommended: {
    label: "Provisional Sanction Not Recommended",
    class: "bg-red-600",
  },
  submitted_for_approval: {
    label: "Submitted for Approval",
    class: "bg-teal-600",
  },
  after_purchase_field_visit_completed: {
    label: "After Purchase Field Visit Completed",
    class: "bg-orange-600",
  },
  district_officer_approve: {
    label: "District Officer Approved",
    class: "bg-green-600",
  },
  district_officer_reject: {
    label: "District Officer Rejected",
    class: "bg-red-600",
  },
  committee_approve: {
    label: "Committee Approved",
    class: "bg-emerald-600",
  },
  committee_reject: {
    label: "Committee Rejected",
    class: "bg-red-600",
  },
};

export default function StatusBadge({ status }) {
  const config = statusConfig[status];

  if (!config) {
    return <Badge className="">NA</Badge>;
  }

  return (
    <Badge className={`${config.class} text-center p-2`}>{config.label}</Badge>
  );
}
